import { useState } from "react";
import { useStyletron } from "baseui";
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from "baseui/modal";
import { FormControl } from "baseui/form-control";
import { Input } from "baseui/input";
import { useUpdateSubscriptionMutation } from "../../../services/resourceGroups/subscriptionApi";
import { getStripeId } from "../../../services/resourceGroups/utils";
import { AccessRoles, useHasRole } from "../../../hooks/useHasRole";
import { ISubscription } from "@oqdo/automationapps/Memberships/Subscription";
import { useReportMutationState } from "../../../hooks/useReportMutationState";
import { FormattedMessage, useIntl } from "react-intl";

function UpdateDialog(props: { isOpen; setIsOpen; subscription: ISubscription }) {
  const { isOpen, setIsOpen, subscription } = props;
  const [state, setState] = useState({
    name: subscription.name,
    stripeSubscriptionId: getStripeId(subscription),
  });
  const intl = useIntl();
  const isSa = useHasRole(AccessRoles.SuperAdmin);
  const [css, theme] = useStyletron();
  const [update, updateResult] = useUpdateSubscriptionMutation();
  useReportMutationState(updateResult, () => setIsOpen(false));

  function close() {
    setIsOpen(false);
  }

  const handleNameChanged = (newName: string) => {
    setState((prev) => {
      return {
        ...prev,
        name: newName,
      };
    });
  };
  const handleStripeIdChanged = (newstripeSubscriptionId: string) => {
    setState((prev) => {
      return {
        ...prev,
        stripeSubscriptionId: newstripeSubscriptionId,
      };
    });
  };

  const handleOk = async () => {
    const newExtIds: any = { ...subscription.externalIds };
    newExtIds.StripeSubscriptionId = state.stripeSubscriptionId;
    await update({
      id: subscription.id,
      data: { name: state.name, externalIds: newExtIds },
    });
  };

  return (
    <>
      <Modal onClose={close} isOpen={isOpen}>
        <ModalHeader>
          <FormattedMessage id="updateSubscriptionHeader" defaultMessage={"Update Subscription"} />
        </ModalHeader>
        <ModalBody>
          <FormControl
            label={() => intl.formatMessage({ id: "name", defaultMessage: "Name" })}
            caption={() =>
              intl.formatMessage({
                id: "nameInputDescr",
                defaultMessage: "Enter a descriptive name for the Subscription",
              })
            }>
            <>
              <Input
                value={state.name}
                onChange={(e) => {
                  handleNameChanged(e.target.value);
                }}
                placeholder="Subscription xy"
                clearable
                clearOnEscape
              />
            </>
          </FormControl>
          {isSa && (
            <FormControl label={() => "Stripe subscription Id"} caption={() => "Enter the Stripe subscription Id"}>
              <>
                <Input
                  value={state.stripeSubscriptionId}
                  onChange={(e) => {
                    handleStripeIdChanged(e.target.value);
                  }}
                  placeholder="sub_...."
                  clearable
                  clearOnEscape
                />
              </>
            </FormControl>
          )}
        </ModalBody>
        <ModalFooter>
          <ModalButton kind="tertiary" onClick={close}>
            <FormattedMessage id="cancel" defaultMessage={"Cancel"} />
          </ModalButton>
          <ModalButton isLoading={updateResult.isLoading} onClick={handleOk}>
            <FormattedMessage id="ok" defaultMessage={"Ok"} />
          </ModalButton>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default UpdateDialog;
